export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
export const SET_MODAL_CLOSED = 'SET_MODAL_CLOSED';
export const ADD_MODAL = 'ADD_MODAL';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ForemanModal/ForemanModalConstants.js